import { createEvent, restore, sample } from 'effector'

import { fx } from '../../../libs'
import {
  Verification,
  VerificationRequest,
  VerificationResponse,
} from './types'
import { transactionRequestDirection } from '../../billing/const'
import { getUsers, usersListMounted } from '../../usersRoles/users/list/model'

const changedDateFormat = (date: Date) =>
  `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`
const DATE_FIELDS = ['updatedAt', 'createdAt']

const mapSearchEntry = (key: string, value: any): [string, any] => {
  if (key === 'requestId') {
    return ['id', value?.toLowerCase()]
  }

  if (key === 'client') {
    return ['client.email', value?.toLowerCase()]
  }

  if (DATE_FIELDS.includes(key)) {
    const dates = Array.isArray(value)
      ? value.map((date) => (date ? changedDateFormat(date?.$d) : `${date}`))
      : value
    return [key, dates]
  }

  return [key, value?.toLowerCase()]
}

const mapSearchText = (searchText: { [key: string]: string }) => {
  return Object.fromEntries(
    Object.entries(searchText).map(([key, value]) =>
      mapSearchEntry(key, value),
    ),
  )
}

const isAllElementsOfSearchTextNotExist = (searchText: {
  [key: string]: string
}) => {
  return Object.values(searchText).every((item) => item === undefined)
}

export const verificationsListMounted = createEvent<VerificationRequest>()

export const getVerifications = fx<VerificationRequest, VerificationResponse>({
  method: 'GET',
  url: `/verification`,
})

export const $verifications = restore<Verification[]>(
  getVerifications.doneData.map((a) => a.body.items),
  [],
)

export const $totalCountOfVerifications = restore(
  getVerifications.doneData.map((a) => a.body.total),
  0,
)
sample({
  clock: verificationsListMounted,
  fn: () => ({}),
  target: getUsers,
})

sample({
  // @ts-ignore
  clock: verificationsListMounted,
  fn: ({ limit, page, orderBy, orderDirection, searchText, filters }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }
    if (orderBy === 'requestId') {
      orderBy = 'id'
    }
    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    if (filters) {
      //TODO данные мапперы необходимо переписать, когда бэк будет паринимать правильный JSON
      let newObj = Object.keys(filters).reduce((accumulator, key) => {
        if (filters[key as keyof typeof filters] != null) {
          accumulator[key as keyof typeof filters] =
            key === 'country' ||
            key === 'status' ||
            key === 'documentType' ||
            key === 'user.email' ||
            key === 'client.products'
              ? filters[key as keyof typeof filters]
              : `${filters[key as keyof typeof filters]}`
        }

        return accumulator
      }, {} as any)

      if (!isAllElementsOfSearchTextNotExist(searchText)) {
        newObj = { ...newObj, ...mapSearchText(searchText) }
      }

      // @ts-ignore
      query['where'] = `${JSON.stringify(newObj)}`
    }

    return {
      query,
    }
  },
  target: getVerifications,
})
